 
import { createSlice } from '@reduxjs/toolkit';
import {
  DXAReadingsState,
  DXAReadingsFetchAction,
  DXAVisitDataFetchSuccessAction,
  DXAReadingsSyncAction,
  DXAReadingsSyncStatusAction,
  DXAWorkstationsDataFetchSuccessAction,
  DXARemoveSelectedReadingAction,
  DXASendSelectedReadingAction,
} from './DXAReadings.types';
import { createSliceHook, makeActionCreator, createSelector } from '../helpers';
import { ExecutionStatus } from '@dynamika-shared/types/executions';

const initialState: DXAReadingsState = {
  loadingReadings: false,
  loadingWorkstationReadings: false,
  error: undefined,
  visitData: null,
  workstationData: [],
  lastSync: '',
  syncStatus: ExecutionStatus.COMPLETED,
};

const { act, actReq, actResolve, actReject, actEmpty } =
  makeActionCreator<DXAReadingsState>();

export const DXAReadingsSlice = createSlice({
  name: 'DXAReadings',
  initialState,
  reducers: {
    fetchDXAReadings:
      actReq<DXAReadingsFetchAction['payload']>('loadingReadings'),
    fetchDXAReadingsSuccess: actResolve<
      DXAVisitDataFetchSuccessAction['payload']
    >('visitData', 'loadingReadings'),
    fetchDXAReadingsFailure: actReject('error', 'loadingWorkstationReadings'),
    fetchDXAWorkstationReadings: actReq<DXAReadingsFetchAction['payload']>(
      'loadingWorkstationReadings'
    ),
    fetchDXAWorkstationReadingsSuccess: actResolve<
      DXAWorkstationsDataFetchSuccessAction['payload']
    >('workstationData', 'loadingWorkstationReadings'),
    fetchDXAWorkstationReadingsFailure: actReject(),
    syncWorkstation: act<DXAReadingsSyncAction['payload']>(() => ({
      syncStatus: ExecutionStatus.IN_PROGRESS,
    })),
    syncWorkstationStatus: act<DXAReadingsSyncStatusAction['payload']>(
      ({ lastSync, status }) => ({
        syncStatus: status,
        lastSync,
      })
    ),
    removeSelectedReading:
      actEmpty<DXARemoveSelectedReadingAction['payload']>(),
    sendToReadings: actEmpty<DXASendSelectedReadingAction['payload']>(),
    getSyncStatus: actEmpty<DXAReadingsSyncAction['payload']>(),
  },
});

export const {
  fetchDXAReadings,
  fetchDXAReadingsSuccess,
  fetchDXAReadingsFailure,
  fetchDXAWorkstationReadings,
  fetchDXAWorkstationReadingsFailure,
  fetchDXAWorkstationReadingsSuccess,
  removeSelectedReading,
  sendToReadings,
  getSyncStatus,
  syncWorkstation,
  syncWorkstationStatus,
} = DXAReadingsSlice.actions;

export const actions = {
  ...DXAReadingsSlice.actions,
};

export const useDXAReadingsSlice = createSliceHook(
  DXAReadingsSlice.name,
  actions
);

export const selectDXAReadingsState = createSelector('DXAReadings');
